<template>
  <template v-if="product?.metafields?.[badgeType]">
    <component
      :is="getBadgeElement(badgeType)"
      :key="`${badgeType}-${product.id}`"
      :style="getBadgeColor(product?.metafields?.[badgeType])"
      :class="getBadgeClasses(formatBadgeText(product?.metafields?.[badgeType]))"
      :href="getBadgeUrl(badgeType)"
      v-html="formatBadgeText(product?.metafields?.[badgeType])"
    />
  </template>
</template>

<script>

/**
 * Vue: Product badge (product-badge)
 * -----------------------------------------------------------------------------
 * Badge displayed on PLP and PDP.
 *
 * @param {Boolean|Object} product - Product object, false shows loading state.
 * @param {String} badgeType - Selects type of badge to return, 'topBadge',
 * 'bottomBade', 'specialtyBadge' or 'preorderBadge'
 * @param {String} badgeElement - Element of badge
 * @param {String} badgeClass - Class of badge
 *
 */
export default {
  name: 'ProductBadge',

  props: {
    product: {
      type: [Boolean, Object],
      default: false,
      required: true,
    },
    badgeType: {
      type: String,
      default: 'badge',
    },
    badgeElement: {
      type: String,
      default: 'span',
    },
    badgeClass: {
      type: String,
      default: null,
    },
  },

  methods: {
    getBadgeUrl(badgeType) {
      if (this.product?.metafields?.[`${badgeType}Url`]) {
        return this.product?.metafields?.[`${badgeType}Url`]
      }

      return false
    },

    getBadgeElement(badgeType) {
      if (this.product?.metafields?.[`${badgeType}Url`]) {
        return 'a'
      }

      return this.badgeElement
    },

    getBadgeClasses(badge) {
      const badgeClasses = { 'product-badge': true }
      if (this.badgeClass) {
        badgeClasses[this.badgeClass] = true
      }

      if (badge.length) {
        badgeClasses[document.createRange().createContextualFragment(badge)
          .textContent.trim().toLowerCase().replaceAll(' ', '-')] = true
      }

      return badgeClasses
    },

    /**
     * Formats badge text from product tag
     * @param {String} badge - Tag to be formatted
     * @returns {String}
     */
    formatBadgeText(badge) {
      if (badge.includes('||')) {
        return badge.split('||')[0]
      }

      return badge
    },

    /**
     * Gets badge modifiers from metafield
     * @param {String} badge - Tag to be formatted
     * @returns {String|Null}
     */
    getBadgeColor(badge) {
      if (badge.includes('||')) {
        const color = badge.split('||')[1].split(':')[1]

        return `color: ${color}; border-color: ${color};`
      }

      return null
    },
  },
}
</script>

<style lang="scss">
@import './product-badge';
</style>
